import { mainAPI, handleApiError } from "../api";
import {
  User,
  GetUsersRequest,
  UsersIdsRequest,
  UsersCountResponse,
  UserProfile,
} from "../types/api/users";

const path = `users/admin/${process.env.REACT_APP_API_VERSION}`;

// Пользователи - Получить список
export function fetchUsers(params?: GetUsersRequest) {
  const queryParams = new URLSearchParams();

  if (params?.is_blocked !== undefined) {
    queryParams.append("is_blocked", String(params.is_blocked));
  }
  if (params?.limit !== undefined) {
    queryParams.append("limit", String(params.limit));
  }
  if (params?.offset !== undefined) {
    queryParams.append("offset", String(params.offset));
  }
  if (params?.ordering) {
    queryParams.append("ordering", params.ordering);
  }
  if (params?.search) {
    queryParams.append("search", params.search);
  }

  const queryString = queryParams.toString();
  const url = queryString
    ? `${path}/profiles?${queryString}`
    : `${path}/profiles`;

  return mainAPI.get<User[]>(url).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data,
        totalCount: countHeader,
      });
    },
    (error) => handleApiError(error)
  );
}

// Пользователи - Заблокировать
export function blockUsers(request: UsersIdsRequest) {
  return mainAPI
    .post<UsersCountResponse>(`${path}/profiles/block`, request)
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => handleApiError(error, "Ошибка при блокировке пользователей")
    );
}

// Пользователи - Разблокировать
export function unblockUsers(request: UsersIdsRequest) {
  return mainAPI
    .post<UsersCountResponse>(`${path}/profiles/unblock`, request)
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => handleApiError(error, "Ошибка при разблокировке пользователей")
    );
}

// Пользователи - Удалить
export function deleteUsers(request: UsersIdsRequest) {
  return mainAPI
    .post<UsersCountResponse>(`${path}/profiles/delete`, request)
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => handleApiError(error, "Ошибка при удалении пользователей")
    );
}

// Пользователи - Экспортировать
export function exportUsers() {
  return mainAPI
    .post(`${path}/profiles/export`, {}, { responseType: "blob" })
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => handleApiError(error, "Ошибка при экспорте пользователей")
    );
}

// Свой профиль - Получить
export function getMyUser() {
  return mainAPI
    .get<User>(`users/${process.env.REACT_APP_API_VERSION}/profile`)
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => handleApiError(error)
    );
}

//Пользователь - Получить
export function fetchUser(id: string) {
  return mainAPI
    .get<UserProfile>(
      `users/admin/${process.env.REACT_APP_API_VERSION}/profiles/${id}`
    )
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => handleApiError(error)
    );
}
